module.exports = __webpack_public_path__ + "static/img/SketchPng5e79a86c266fb8f054fd2d8ce46aff6d97aacdd051e5985afa1132556c403f42.87e22124.png";